<template>
  <div id="app" class="container-fluid no-padding">
    <router-view v-if="isMobile()" name="mobile"></router-view>
    <router-view v-else></router-view>
    <!--<div id="box-cookie" class="col-xs-24" :style="[infoCookie ? {'height': '0px'} : {}]">
      <p class="testo" v-html="$t('cookie')"></p>
      <el-button @click="setCookie">{{$t('btn_continua')}}</el-button>
    </div>-->
  </div>
</template>

<script>
import { messaging, getTokenFCM } from './firebase'

export default {
  name: 'App',
  i18n: {
    messages: {
      it_IT: {
        btn_continua: 'CONTINUA',
        cookie: 'Questo sito utilizza cookie tecnici e cookie di terze parti per migliorare la tua esperienza di navigazione. Se vuoi saperne di più o negare il consenso ad alcuni cookie <a href="static/docs/Cookie_it_IT.pdf" target="_blank">clicca qui</a>. Chiudendo questo banner o continuando la navigazione sulsito acconsenti all’utilizzo dei cookie.'
      },
      en_GB: {
        btn_continua: 'CONTINUE',
        cookie: 'This site uses technical cookies and third-party cookies to improve your browsing experience. If you want to learn more or opt out of some cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">click here</a>. By closing this banner or continuing browsing the site, you consent to the use of cookies.'
      },
      es_ES: {
        btn_continua: 'CONTINUAR',
        cookie: 'Este sitio utiliza cookies técnicas y cookies de terceros para mejorar su experiencia de navegación. Si desea obtener más información o cancelar algunas cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">haga clic aquí</a>. Al cerrar este banner o continuar navegando por el sitio, usted acepta el uso de cookies.'
      },
      fr_FR: {
        btn_continua: 'CONTINUE',
        cookie: 'Ce site utilise des cookies techniques et des cookies tiers pour améliorer votre expérience de navigation. Si vous voulez en savoir plus ou refuser certains cookies <a href="static/docs/Cookie_it_IT.pdf" target="_blank">cliquez ici</a>. En fermant cette bannière ou en continuant à naviguer sur le site, vous consentez à l\'utilisation de cookies.'
      },
      de_DE: {
        btn_continua: 'WEITER',
        cookie: 'Diese Website verwendet technische Cookies und Cookies von Drittanbietern, um Ihre Browser-Erfahrung zu verbessern. Wenn Sie mehr erfahren oder einige Cookies ablehnen möchten <a href="static/docs/Cookie_it_IT.pdf" target="_blank">klick hier</a>. Indem Sie dieses Banner schließen oder die Seite weiter durchsuchen, stimmen Sie der Verwendung von Cookies zu.'
      }
    }
  }
  ,
  data() {
    return {
      isDesktop: false,
      infoCookie: true,
      JWT_PeriodoCritico: 780,
      JWT_DurataToken: 900
    }
  },
  methods: {
    /* setCookie: function () {
      localStorage.setItem('cookie', 'true')
      this.infoCookie = true
    } */
  },
  created: function () {
    let _this = this
    setInterval(function () {
      if (sessionStorage.getItem('token')) {
        let token_dtCreation = _this.$store.state.token_dtCreation
        let token_dtUpdate = _this.$store.state.token_dtUpdate
        let adesso = Math.round(Date.now() / 1000)
        if (token_dtUpdate > token_dtCreation && (adesso >= token_dtCreation + _this.JWT_PeriodoCritico)) {
          _this.verifyToken()
        } else if (adesso > token_dtUpdate + _this.JWT_DurataToken) {
          // Verifico se sono passati più di 15 minuti dall'ultima volta che è stato richiamato un qualsiasi Web Service
          sessionStorage.setItem('token', '')
          sessionStorage.removeItem('token')
          sessionStorage.setItem('token_download', '')
          sessionStorage.removeItem('token_download')
          sessionStorage.setItem('menu', '')
          sessionStorage.removeItem('menu')
          sessionStorage.setItem('Trasferte_form', '')
          sessionStorage.removeItem('Trasferte_form')
          sessionStorage.setItem('Trasferte_Aut_form', '')
          sessionStorage.removeItem('Trasferte_Aut_form')
          _this.$router.push({ name: 'Login' })
        }
      }
    }, 60000);
  },
  mounted: function () {
    // 🔔 Inizializzo FCM
    if (messaging) {
      // NON richiedere permesso qui, ma nella pagina di Login
      /*Notification.requestPermission().then(permission => {
        if (permission === 'granted') {
          getTokenFCM() // la nostra funzione compat
            .then(token => {
              console.log('✅ Token FCM Browser:', token)
              // 👉 qui puoi inviarlo al backend con una API
            })
            .catch(err => {
              console.error('❌ Errore ottenendo token FCM:', err)
            })
        } else {
          console.warn('⚠️ Notifiche non permesse dall\'utente')
        }
      })*/

      // 📩 Listener per notifiche in foreground
      messaging.onMessage(payload => {
        console.log('📨 Notifica ricevuta:', payload)
        alert(`Nuova notifica: ${payload.notification.title}`)
      })
    }
  },
  methods: {
    verifyToken: function () {
      this.$http.post('portale/' + this.$store.state.country + '/updateToken').then(response => {
        if (response.status === 201) {
          sessionStorage.setItem('token', response.body.wsToken)
          this.$store.commit('set', { key: 'token_dtCreation', value: Math.round(Date.now() / 1000) })
        }
      }, response => {
        this.isErrorLogin = true
      })
    }
  }
}
</script>

<style lang="less">
@import "./assets/less/general.less";
@import './assets/less/general-element.less';

.no-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.row-custom {
  margin-left: 0px;
  margin-right: 0px;
}

.padding {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.padding-mobile {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.margin {
  margin-left: 15px !important;
  margin-right: 15px !important;
}

.pointer:hover {
  cursor: pointer;
}

body {
  margin: 0px;
  height: 100%;
  background-color: #eef4f9;
  overflow: hidden;
}

.el-select {
  .el-input__icon {
    line-height: 0px !important;
  }
}

.el-message-box {
  border-radius: 0px;

  .el-message-box__header {
    padding: 7px 10px;

    .el-message-box__title {
      .set-font(@size: 16px; @weight: bold; @color: @greenRiva);
    }

    .el-message-box__headerbtn {
      top: 5px;
    }
  }

  .el-message-box__content {
    .el-message-box__message {
      .set-font(@color: #666; @size: 14px);
    }
  }

  .el-message-box__btns {
    .el-button {
      border: 1px solid @rossoRiva;
      background-color: @white;
      border-radius: 0;
      // -moz-box-shadow: 3px 3px 4px #cccccc;
      // -webkit-box-shadow: 3px 3px 4px #cccccc;
      // box-shadow: 3px 3px 4px #cccccc;
      line-height: 0;
      padding: 13px 13px;
      .set-font(@family: 'os-regular', @size: 13px, @color: @rossoRiva);
      letter-spacing: 2px;
      outline-color: @oroRiva;

      &.is-disabled:hover {
        border: 1px solid @grayLight !important;
        background-color: @grayLight !important;
        color: @grayMedium !important;
      }
    }

    /*.el-button:hover {
        background-color: @white;
      }*/
    .el-button--primary {
      border: 1px solid @rossoRiva;
      background-color: @rossoRiva;
      color: @white !important;

      &.is-disabled:hover {
        border: 1px solid @grayLight !important;
        background-color: @grayLight !important;
        color: @grayMedium !important;
      }
    }

    /*.el-button--primary:hover {
        background-color: @oroRiva;
      }*/
  }
}

.el-select-dropdown {
  .el-select-dropdown__item {
    height: 22px;
    line-height: 22px;
    padding: 0px 10px;
    .set-font(@size: 11px; @color: #666);

    span {
      line-height: 22px !important;
    }
  }
}

.el-date-picker {
  .el-picker-panel__body {
    .el-date-table {
      tbody tr td {
        &.today span {
          color: @greenRiva;
        }

        &.current:not(.disabled) span {
          background-color: @greenRiva;
          color: @white;
        }

        &.available:hover {
          color: @greenRiva;
        }
      }
    }

    .el-month-table {
      tbody tr td {
        &.current:not(.disabled) {
          .cell {
            .set-font(@weight: bold; @size: 11px);
            text-decoration: underline;
          }
        }

        .cell:hover {
          .set-font(@weight: bold; @size: 11px);
          text-decoration: none;
        }
      }
    }

    .el-year-table {
      tbody tr td {
        &.current:not(.disabled) {
          .cell {
            .set-font(@weight: bold; @size: 11px);
            text-decoration: underline;
          }
        }

        .cell:hover {
          .set-font(@weight: bold; @size: 11px);
          text-decoration: none;
        }
      }
    }

    .el-date-picker__header {
      .el-date-picker__header-label:hover {
        .set-font(@weight: bold; @size: 16px);
      }

      .el-picker-panel__icon-btn:hover {
        color: @greenRiva;
      }
    }
  }
}

.time-select {
  .el-scrollbar {
    .time-select-item {
      &.selected {
        color: @greenRiva;
      }
    }
  }
}

.el-time-panel {
  .el-time-spinner {
    .el-scrollbar__wrap {
      overflow-x: hidden !important;
      margin-bottom: 0 !important;
    }
  }
}

.el-dropdown-menu {
  padding: 3px 0px;

  .el-dropdown-menu__item:hover {
    color: @greenRiva;
    background-color: #eef4f9;
  }
}

.el-pagination {
  margin-top: 10px;
  padding-bottom: 5px;
  width: 100%;
  text-align: center;

  .el-pager li.active {
    background-color: #007c74 !important;
    color: #d4d4d4 !important;
    height: 26px;
    border-radius: 0px;
    border: 1px solid #cccccc;
  }

  .el-pager li {
    color: #cccccc;
    height: 26px;
    line-height: 20px;
    margin: 0px !important;
    border: 1px solid #cccccc;
    border-radius: 0px !important;
    border-right: 0px;
    line-height: 24px;
    background-color: @white !important;
  }

  .el-pager li:hover {
    color: @greenRiva !important;
  }

  .btn-prev {
    height: 26px;
    border: 1px solid #cccccc;
    border-right: 0px;
    margin: 0px !important;
    border-radius: 0px !important;
    background-color: @white !important;
    color: #cccccc;
  }

  .btn-next {
    height: 26px;
    border: 1px solid #cccccc;
    margin: 0px !important;
    border-radius: 0px !important;
    background-color: @white !important;
    color: #cccccc;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .6s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.modal-riva {
  .set-font();

  &.el-dialog__wrapper {
    .el-dialog {
      border-radius: 0px;

      .el-dialog__close {
        color: @greenRiva;
      }

      .el-dialog__header {
        padding: 7px 0px 2px 0px;
        border-bottom: 1px solid @greenRiva;
        width: 98%;
        line-height: 0px;
        margin: auto;
        text-align: left;

        .el-dialog__title {
          .set-font(@size: 14px; @weight: bold; @color: @greenRiva);
        }

        .el-dialog__headerbtn {
          top: 10px;
          right: 3%;
        }
      }

      .el-dialog__body {
        text-align: left;
        padding: 20px 0px;
        margin: auto;
        width: 98%;

        .bottoni {
          .el-button {
            letter-spacing: 2px;
            border: 1px solid @oroRiva;
            background-color: @oroRiva;
            .set-font(@color: @white; @size: 12px);
            border-radius: 0px;
            -moz-box-shadow: 3px 3px 4px #cccccc;
            -webkit-box-shadow: 3px 3px 4px #cccccc;
            box-shadow: 3px 3px 4px #cccccc;
            margin-bottom: 20px;
            margin-top: 20px;
            padding: 1px 12px;
            height: 27px;
            float: right;
          }

          .el-button--primary {
            float: right;
            background-color: @white;
            border-color: @oroRiva;
            .set-font(@size: 12px; @color: @oroRiva);
            letter-spacing: 2px;
            margin-right: 15px !important;
            margin-bottom: 20px;
          }
        }
      }

      .el-dialog__footer {
        padding: 10px 0px 20px 0px;

        .el-button {
          border: 1px solid @oroRiva;
          color: @oroRiva;
          border-radius: 0px;
          font-size: 12px;
          text-transform: uppercase;
          letter-spacing: 2px;
          -moz-box-shadow: 3px 3px 4px #cccccc;
          -webkit-box-shadow: 3px 3px 4px #cccccc;
          box-shadow: 3px 3px 4px #cccccc;
          padding: 8px 12px;
        }

        .el-button:hover {
          background-color: @white;
        }

        .el-button--primary {
          background-color: @oroRiva;
          border-color: @oroRiva;
          color: @white;
          font-size: 12px;
          letter-spacing: 2px;
        }

        .el-button--primary:hover {
          background-color: @oroRiva;
        }
      }
    }
  }
}

#app {
  .set-font();
  height: 100%;

  .language-modal {
    .elemento {
      font-size: 14px;
      margin-top: 5px;
      margin-bottom: 20px;

      .label {
        color: #007c74;
      }

      .radio {
        margin-top: 5px;
        color: #007c74;
      }

      .value {
        color: #bbbbbb;
      }

      .textarea:focus {
        border: 1px solid #007c74;
      }
    }
  }

  #box-cookie {
    position: fixed;
    bottom: 0;
    background-color: #717171;
    z-index: 2;
    //border-top: 1px solid #76ca68;
    height: 70px;
    transition: .3s ease;
    z-index: 10;

    .testo {
      width: 88%;
      float: left;
      padding: 10px 25px;
      .set-font(@color: @white, @size: 13px);

      a {
        color: #76ca68;
      }
    }

    .el-button {
      float: left;
      margin-top: 15px;
      border: 0;
      border-radius: 0;
      height: 40px;
      background-color: #000;
      text-transform: uppercase;
      .set-font(@size: 14px, @color: @white);

      &:hover {
        background-color: #000;
        cursor: pointer;
      }

    }
  }
}

.no-padding-left {
  padding-left: 0px;
}

.no-padding-right {
  padding-right: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue